<template>
    <div class="team" :class="{'teamDark':isDark}">
        <div class="topBox">
            <div class="headerBox" v-if="teamInfo">
                <headSssembly
                    :showSearch="true" :showShare="isShowShare"
                    :titleTransparent="teamInfo ? teamInfo.name_s : ''"
                    :logo="teamInfo ? teamInfo.logo : ''"
                    type="team"
                    @share="share"
                />
                <div class="userInfo">
                    <div class="headPortrait">
                        <img :src="teamInfo.logo || 'https://s.jihai8.com/h5/image/player/hotdefaultbasketball.png'" alt="">
                    </div>
                    <div class="text">
                        <p class="name">{{teamInfo.name_s}}</p>
                        <p class="english">{{teamInfo.name_e}}</p>
                        <p class="field">主场：{{teamInfo.gymnasium}}</p>
                    </div>
                    <div class="other">
                        <div class="follow" @click="getFollowTeam(teamInfo, teamInfo.is_follow)">
                            {{teamInfo.is_follow == 0 ? '关注' : '已关注'}}
                        </div>
                        <div class="fans">{{teamInfo.fans}}粉丝</div>
                    </div>
                </div>
                <div class="modular">
                    <div class="item">
                        <span>{{teamInfo.alliance_name}}第<em>{{teamInfo.total_order}}</em></span>
                        <span>联赛排名</span>
                    </div>
                    <div class="item">
                        <span><em>{{teamInfo.away_win * 1 + teamInfo.home_win * 1}}</em>胜<em>{{teamInfo.away_loss * 1 + teamInfo.home_loss * 1}}</em>负</span>
                        <span>联赛战绩</span>
                    </div>
                    <div class="item">
                        <span><em>{{(teamInfo.state && Math.abs(teamInfo.state*1))|| '-'}}</em>连{{teamInfo.state && teamInfo.state*1 > 0 ? '胜' : '负'}}</span>
                        <span>连胜/练负</span>
                    </div>
                    <div class="item">
                        <span><em>{{teamInfo.first_times}}</em></span>
                        <span>总冠军数</span>
                    </div>
                </div>
            </div>
            <div class="tabs">
                <span :class="{active: tabs == 'database'}" @click="tabs = 'database'">资料</span>
                <span :class="{active: tabs == 'schedule'}" @click="tabs = 'schedule'">赛程</span>
                <span :class="{active: tabs == 'lineup'}" @click="tabs = 'lineup'">阵容</span>
                <span :class="{active: tabs == 'data'}" @click="tabs = 'data'">数据</span>
                <span :class="{active: tabs == 'dynamic'}" @click="tabs = 'dynamic'">动态</span>
            </div>
        </div>
        <div class="main" id="mainHeight">
            <!-- <keep-alive> -->
                <router-view />
            <!-- </keep-alive> -->
        </div>
    </div>
</template>

<script>
import headSssembly from "@/components/common/headSssembly"
import { getFollowTeam } from "@/api/team.js"
import { doLogin } from "@/utils/base.js"
import jsbridg from "@/utils/jsbridg.js"
export default {
    name: "team",
    components: {
        headSssembly
    },
    data () {
        return {
            tabs: 'database',
            data: null,
            team_id: this.$route.query.team_id || 1,
            mainHeight: 0
        }
    },
    created () {
        jsbridg.hideAppBar(0)
        this.tabs = this.$route.name
        this.$store.dispatch('getLQTeamInfo', { id: this.team_id })
    },
    computed: {
        teamInfo () {
            return this.$store.state.team.teamInfo
        },
        isDark () {
            return this.$store.state.common.isDark
        },
        isShowShare () {
            const src = this.$route.query.src
            if (src) {
                if (src.split('_')[2] === '106') {
                    return false
                } else {
                    return true
                }
            } else {
                return true
            }
        }
    },
    watch: {
        tabs (news) {
            this.$router.push({
                path: `/team/${news}`,
                query: this.$route.query
            })
        },
        $route: {
            handler () {
                this.tabs = this.$route.name
            }
        }
    },
    methods: {
        share () {
            var shareobj = {
                title: this.teamInfo ? this.teamInfo.name_s : '',
                desc: "查看球队最新动态、详细资料等",
                link: window.location.href,
                imgUrl: this.teamInfo.logo
            }
            jsbridg.appShare(shareobj);
        },
        async getFollowTeam (item, status) {
            const params = {
                team_id: item.team_id,
                status: status * 1 === 0 ? 1 : 0
            }
            const res = await getFollowTeam(params)
            if (res.errno * 1 === 0) {
                if (item.is_follow === 1) {
                    this.$toast("取消成功")
                    item.is_follow = 0
                } else {
                    this.$toast("关注成功")
                    item.is_follow = 1
                }
            } else if (res.errno * 1 === -1) {
                doLogin()
            } else {
                this.$toast(res.errmsg)
            }
        }
    }
}
</script>

<style lang="less" scoped>
.team{
    .topBox{
        position: sticky;
        top: 0;
        z-index: 2000;
    }
    .headerBox{
        background: #3755D1;
        .userInfo{
            padding: 0 14px;
            display: flex;
            align-items: center;
            .headPortrait{
                width: 60px;
                height: 60px;
                border-radius: 50%;
                overflow: hidden;
                img{
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
            }
            .text{
                margin-left: 10px;
                width: 220px;
                .name{
                    font-size: 17px;
                    font-weight: bold;
                    color: #FFFFFF;
                }
                .english{
                    font-size: 13px;
                    font-weight: 400;
                    color: #FFFFFF;
                }
                .field{
                    font-size: 13px;
                    font-weight: 400;
                    color: #9BAAE8;
                }
            }
            .other{
                flex: 1;
                .follow{
                    width: 57px;
                    height: 25px;
                    border-radius: 15px;
                    border: 1px solid #FFFFFF;
                    font-size: 12px;
                    font-weight: 400;
                    color: #FFFFFF;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
                .fans{
                    font-size: 13px;
                    font-weight: 400;
                    color: #FFFFFF;
                    line-height: 19px;
                    margin-top: 20px;
                }
            }
        }
        .modular{
            padding: 0 14px;
            margin-top: 13px;
            display: flex;
            align-items: center;
            .item{
                flex: 1;
                height: 45px;
                background: #3755D1;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: flex-start;
                span{
                    &:first-child{
                        font-size: 10px;
                        font-weight: 400;
                        color: #FFFFFF;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        em{
                            font-size: 15px;
                            font-weight: bold;
                            color: #FFFFFF;
                        }
                    }
                    &:last-child{
                        font-size: 10px;
                        font-weight: 400;
                        color: #9BAAE8;
                        line-height: 14px;
                    }
                }
            }
        }
    }
    .tabs{
        display: flex;
        align-items: center;
        justify-content: center;
        height: 35px;
        border-bottom: 1px solid #EEEEEE;
        background: #fff;
        span{
            flex: 1;
            font-size: 14px;
            font-weight: 400;
            color: #666666;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            height: 100%;
        }
        .active{
            font-size: 14px;
            font-weight: bold;
            color: #333333;
            position: relative;
            &::after{
                position: absolute;
                bottom: 0;
                content: '';
                width: 18px;
                height: 3px;
                background: #169AFF;
                border-radius: 1px;
            }
        }
    }
    .main{
        position: relative;
    }
}
.teamDark{
    .tabs{
        background-color: #191919;
        border-color: #2f2f2f;
        span{
            color: #a6a6a6;
        }
        .active{
            color: #d3d3d3;
        }
    }
}
</style>
